import { render } from "./GalleryPopUp.vue?vue&type=template&id=3e27c57c&scoped=true"
import script from "./GalleryPopUp.vue?vue&type=script&lang=js"
export * from "./GalleryPopUp.vue?vue&type=script&lang=js"

import "./GalleryPopUp.vue?vue&type=style&index=0&id=3e27c57c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e27c57c"]])

export default __exports__